import { NavigationService } from './navigation.service';
import { SideNavService } from './side-nav.service';

export const services = [NavigationService, SideNavService];

export * from './navigation.service';
export * from './side-nav.service';
